const CardModel = require('../../../../shared/sharedModels').GreySpaceCard;

const Constants = {
   SetCurrentCard: 'G_SetCurrentCard',
   SetCurrentCardField: 'G_SetCurrentCardField',
   SetCardList: 'G_SetCardList',
   AddCard: 'G_AddCard',
   RemoveCard: 'G_RemoveCard',
   AddEvidenceToCreation: 'G_AddEvidenceToCreation',
   RemoveEvidenceFromCreation: 'G_RemoveEvidenceFromCreation',
   SetCreationEvidence: 'G_SetCreationEvidence',
};

exports.GreySpaceCardReducer = (state={},action) =>{
   switch(action.type){
      case Constants.SetCurrentCard:
         return {...state, curCard: new CardModel(action.card)};
      case Constants.SetCurrentCardField: {
         const curCard = state.curCard;
         const newCard = Object.assign({}, curCard, {[action.field]: action.value});
         return Object.assign({}, state, {curCard: new CardModel(newCard)});
      }
      case Constants.SetCardList:
         return {...state, cardList: action.cardList};
      case Constants.AddCard:{
         let cardList = state.cardList.slice();
         cardList.push(action.card);
         return {...state, cardList}
      }
      case Constants.RemoveCard:{
         let cardList = state.cardList.slice();
         for(let i = 0; i < cardList.length; i++){
            if(cardList[i].idGreySpaceCard === action.idCard){
               cardList.splice(i,1);
               break;
            }
         }
         return {...state, cardList}
      }
      case Constants.AddEvidenceToCreation:{
         let creationEvidence = state.creationEvidence.slice();
         if(creationEvidence.length < 2 && !creationEvidence.includes(action.evidence)){
            creationEvidence.push(action.evidence);
         }
         return {...state, creationEvidence}
      }
      case Constants.RemoveEvidenceFromCreation:{
         let creationEvidence = state.creationEvidence.slice();
         if(creationEvidence[0].id === action.id){
            creationEvidence.shift();
         }
         else if(creationEvidence[1].id === action.id){
            creationEvidence.pop();
         }
         return {...state, creationEvidence}
      }
      case Constants.SetCreationEvidence:{
         return {...state, creationEvidence: action.creationEvidenceArray}
      }
      default:
         return state;
   }
};

const FunctionList = {};

FunctionList.setCurrentCard = (card) => {
   return{
      type: Constants.SetCurrentCard,
      card
   }
};

FunctionList.setCurrentCardField = (field, value) => {
   return{
      type: Constants.SetCurrentCardField,
      field,
      value
   }
};

FunctionList.setCardList = (cardList) => {
   return{
      type: Constants.SetCardList,
      cardList
   }
};

FunctionList.addCard = (card) => {
   return{
      type: Constants.AddCard,
      card
   }
};

FunctionList.removeCard = (idCard) => {
   return{
      type: Constants.RemoveCard,
      idCard
   }
};

FunctionList.addEvidenceToCreation = (evidence) => {
   return{
      type: Constants.AddEvidenceToCreation,
      evidence,
   }
};

FunctionList.removeEvidenceFromCreation = (id) => {
   return{
      type: Constants.RemoveEvidenceFromCreation,
      id,
   }
};

FunctionList.setCreationEvidence = (creationEvidenceArray) => {
   return{
      type: Constants.SetCreationEvidence,
      creationEvidenceArray
   }
};

exports.FunctionList = FunctionList;
